import {css} from "styled-components"
import {WorkSansMedium, WorkSansBold} from "../../global/fonts"

interface Props {
  bold?: boolean
}

export default css<Props>`
  ${WorkSansMedium}
  ${({bold}) => bold && WorkSansBold}
  text-transform: uppercase;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 1px;
  text-decoration: none;

  :hover{
    ${WorkSansBold}
  }
`
